/**
 * OrbDocCoreConceptsTraitsENDocEx2DialView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsTraitsENDocEx2Dial
 */

import { useOrbDocCoreConceptsTraitsENDocEx2DialLogic } from '@/hooks/traits/useOrbDocCoreConceptsTraitsENDocEx2DialLogic';
import type { OrbDocCoreConceptsTraitsENDocEx2DialConfig } from '@/hooks/traits/useOrbDocCoreConceptsTraitsENDocEx2DialLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsTraitsENThermostat } from '@app/shared';
import { Button } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsTraitsENDocEx2DialViewProps {
  config?: Partial<OrbDocCoreConceptsTraitsENDocEx2DialConfig>;
}

export function OrbDocCoreConceptsTraitsENDocEx2DialView({ config: propsConfig }: OrbDocCoreConceptsTraitsENDocEx2DialViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsTraitsENDocEx2DialLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsTraitsENThermostat'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsTraitsEN" trait="OrbDocCoreConceptsTraitsENDocEx2Dial">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="horizontal" gap="md" align="center"><Button label="Colder" action="OrbDocCoreConceptsTraitsEN.OrbDocCoreConceptsTraitsENDocEx2Dial.DOWN" variant="secondary" /><Typography content={renderPatternValue([fields?.target, " °C"].join(''))} variant="h2" /><Button label="Warmer" action="OrbDocCoreConceptsTraitsEN.OrbDocCoreConceptsTraitsENDocEx2Dial.UP" variant="secondary" /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsTraitsENDocEx2DialView;
